<template>
  <div class="filter-wrapper">
    <div class="filter-input">
      <v-autocomplete outline flat dense hide-details height="38" :items="staffListEmail" v-model="filter.agentEmail"
                      placeholder="Supporter" clearable :append-icon='`${filter.agentEmail ? "" : $vuetify.icons.dropdown}`'
                      style="width: 180px" @change="onChangeFilter">
      </v-autocomplete>
    </div>
    <div>
      <v-autocomplete outline flat dense hide-details height="38" :items="channelList" v-model="filter.channel"
                      placeholder="Channel" item-text="text" style="width: 180px"
                      item-value="value" clearable :append-icon='`${filter.channel ? "" : $vuetify.icons.dropdown}`' @change="onChangeFilter">
      </v-autocomplete>
    </div>
    <div class="filter-input">
      <DatePickerOutline
          flat
          v-model="filter.from"
          :max="filter.to"
          hide-details
          append-icon="mdi-calendar"
          prepend-inner-icon=""
          @change="onChangeFilter"
      />
    </div>
    <div class="filter-input">
      <DatePickerOutline
          flat
          hide-details
          append-icon="mdi-calendar"
          v-model="filter.to"
          :min="filter.from"
          :max="today"
          prepend-inner-icon=""
          @change="onChangeFilter"
      />
    </div>
    <v-btn color="primary" depressed class="text-none" @click="onChangeFilter">
      <v-icon size="16" class="pr-1">mdi-sync</v-icon>
      Refresh
    </v-btn>
  </div>
</template>

<script>
import DatePickerOutline from "components/custom/DatePickerOutline";
import moment from "moment";
import { mapState} from "vuex";
import $const from "@/utils/const";
import upperFirst from "lodash/upperFirst";
import {sync} from "vuex-pathify";
import router from "@/router";

export default {
  name: "RateAgentFilterBox",
  components: {
    DatePickerOutline
  },
  data() {
    return {
      today: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapState(['botStaffList']),
    filter: sync('rating/rateAgentFilters'),
    staffListEmail() {
      const botStaffList = this.botStaffList.find(o => o.bot_code === router.currentRoute.params.bot_code)
      return botStaffList ? botStaffList.staffs.map((o) => o.email) : []
    },
    channelList() {
      return $const.ALL_CHAT_CHANNELS.map(o => {
        return {text: upperFirst(this.$t(o)), value: o}
      })
    }
  },
  methods: {
    onChangeFilter() {
      this.$emit("on-refresh", {
        selectAgent: this.selectAgent,
        selectChannel: this.selectChannel,
        fromDate: this.fromDate,
        toDate: this.toDate
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}

::v-deep input {
  font-size: 14px;
}
::v-deep i {
  font-size: 20px !important;
}
.filter-wrapper {
  display: flex;
  gap: 10px;

  .filter-input {
    height: 38px;
  }

  button {
    margin: 0 6px;
    height: 38px;
    border-radius: 5px;
  }
}
</style>